import { Text, rem } from "@mantine/core";

export default function Footer({ className }: { className?: string }) {
  return (
    <footer className={className}>
      <Text c="gray.6" p={{ base: rem(12), md: rem(24) }} size="sm" ta="center">
        Tribeca Printworks LLC 333 Hudson St, rm 201, New York, NY 10013
        <br />
        Copyright 2023 Tribeca Printworks LLC | Sitemap
      </Text>
    </footer>
  );
}
